<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :buttonsVisibility="buttonsVisibility"
                :rowButtonAction="rowButtonAction"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <PermissionForm :formProps="formProps">
                </PermissionForm>
            </template>
            <template #search="searchProps">
                <PermissionSearch :searchProps="searchProps">
                </PermissionSearch>
            </template>

        </v-view>
    </div>
</template>

<script setup>
import PermissionForm from './PermissionForm.vue'
import PermissionSearch from './PermissionSearch.vue'
import { rowButtonAction } from '@pages/Helper/crud_utils.js'
import { ref } from "vue";

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
})

const selectedRows = ref([])

//------------------------------------------------------------------------------

</script>

<style lang="scss"
       scoped></style>
